export const AUTH_BASE_URL_JIRA = 'https://auth.atlassian.com/authorize';
export const STATE_PARAMS_VALUE_JIRA = 'jira-state';
